export const imageSourcePrefix = 'https://filer.oplevalt.dk/experience/';

export const theme = {
	orange: {
		vibrant: '#ffa500',
		neutral: '#fff6ed',
		opaque: '#fffbf7',
	},
};
